import LandingPageContentWithFooter from "../../LandingPageContentWithFooter";
import { MainContainer, MainWrapper } from "../../Layout/MainOutlet";

const LandingPageWrapper = ({
  backgroundColor = "white",
  children,
  className,
  wrapperClassName,
  includeFooter = false,
}: {
  backgroundColor?: "grey" | "white";
  children: React.ReactNode;
  className?: string;
  wrapperClassName?: string;
  includeFooter?: boolean;
}) => {
  if (includeFooter) {
    return (
      <LandingPageContentWithFooter>
        <MainContainer
          className={className}
          style={{
            background: backgroundColor === "white" ? "#ffffff" : "#f6f8fa",
          }}
        >
          <MainWrapper className={wrapperClassName}>{children}</MainWrapper>
        </MainContainer>
      </LandingPageContentWithFooter>
    );
  }

  return (
    <MainContainer
      className={className}
      style={{
        background: backgroundColor === "white" ? "#ffffff" : "#f6f8fa",
      }}
    >
      <MainWrapper className={wrapperClassName}>{children}</MainWrapper>
    </MainContainer>
  );
};

export default LandingPageWrapper;
